module.exports = "<p>\n  advertisement works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/advertisement.component.html
// module id = ../../../../../src/app/themes/default/html/advertisement.component.html
// module chunks = 1